import theme from '../../../lib/theme';

const {
  scale,
  layouts,
  media,
  colors,
  font: {
    families,
    heights,

    ...font
  },
} = theme;
export default () => ({
  container: {
    ...layouts.column,

    '& > *': {
      marginBottom: scale.l,
    },

    '& > *:last-child': {
      marginBottom: 0,
    },

    [media.l.up]: {
      ...layouts.row,

      alignItems: 'flex-start',

      '& > *': {
        marginBottom: 0,
        marginRight: scale.m,
      },

      '& > *:last-child': {
        marginRight: 0,
      },
    },
  },

  title: {
    color: colors.black,
    fontFamily: families.primary,
    fontWeight: font.bold,
    margin: 0,
    fontSize: font.xxl,
    lineHeight: heights.xxl,

    [media.s.up]: {
      fontSize: font.xxxl,
      lineHeight: heights.xxxl,
    },
  },

  num: {
    color: colors.dark_grey,
    fontFamily: families.copy,
    fontSize: font.xxxl,
    lineHeight: heights.xxxl,
    fontStyle: 'italic',
    textAlign: 'start',
    width: '0.75em',
  },
});
